<template>
  <v-data-table class="border-0 rounded-lg elevation-0" :headers="headers" :items="invoices" :loading="loading"
    loading-text="Loading... Please wait" no-data-text="No invoices yet" v-model:page="page"
    v-model:items-per-page="itemsPerPage" :items-per-page-options="[5, 10, 25, 50]">
    <template v-slot:loading>
      <v-skeleton-loader type="table-row@5" />
    </template>
    <template v-slot:no-data>
      <div class="empty-state text-center py-8">
        <v-icon size="64" color="grey-lighten-1" class="mb-4">mdi-file-document-outline</v-icon>
        <h3 class="text-title-large text-grey-darken-1 mb-2">{{ emptyStateTitle }}</h3>
        <p class="text-body-medium text-grey-darken-1 mb-4">{{ emptyStateMessage }}</p>
        <v-btn v-if="!hasSubscription && !hasSubscriptionElsewhere" color="brand-color" @click="$emit('view-plans')">
          View Plans
        </v-btn>
      </div>
    </template>
    <template #[`item.serial`]="{ index }">
      {{ (page - 1) * itemsPerPage + index + 1 }}
    </template>
    <template #[`item.status`]="{ item }">
      <v-chip :color="item.status === 'completed' ? 'success' : 'primary'" size="small" variant="flat"
        class="font-weight-medium text-capitalize">
        {{ item.status }}
      </v-chip>
    </template>
    <template #[`item.receipt_url`]="{ item }">
      <v-btn class="ma-0" size="small" color="brand-color" icon="mdi-eye" variant="text"
        @click="$emit('view-invoice', item)"></v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'InvoiceTable',
  props: {
    invoices: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasSubscription: {
      type: Boolean,
      default: false
    },
    // Whether the user has a subscription on the OTHER Paddle provider, so an empty table
    // here can be worded as "nothing under this provider" instead of "no subscription at all".
    hasSubscriptionElsewhere: {
      type: Boolean,
      default: false
    }
  },
  emits: ['view-invoice', 'view-plans'],
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      headers: [
        { title: '#', key: 'serial', align: 'center', sortable: false, width: '8%' },
        { title: 'Date', key: 'created_at', align: 'start', width: '20%' },
        { title: 'Amount', key: 'amount', align: 'start', sortable: false, width: '16%' },
        { title: 'Order ID', key: 'order_id', align: 'start', sortable: false, width: '28%' },
        { title: 'Status', key: 'status', align: 'center', width: '14%' },
        { title: 'Invoice', key: 'receipt_url', align: 'center', sortable: false, width: '14%' }
      ]
    }
  },
  computed: {
    emptyStateTitle() {
      if (this.hasSubscription) return 'No Invoices Found'
      if (this.hasSubscriptionElsewhere) return 'Nothing Here'
      return 'No Subscription Yet'
    },
    emptyStateMessage() {
      if (this.hasSubscription) return 'Invoices will appear once a charge is generated.'
      if (this.hasSubscriptionElsewhere) return 'No invoices under this billing history.'
      return 'Choose a plan to start generating invoices for your account.'
    }
  }
}
</script>
